import React, { useState } from 'react'
import { StyledLink } from 'components/Tag/Tag.style'
import { useTranslation } from 'react-i18next'
import { BasicAddressEntityType } from 'types/ApiResponse'
import copyIcon from 'assets/images/icons/copy.svg'
import {
  AddressRowContainerStyled,
  ChipStyled,
  FromButtonDetailsStyled,
  FromButtonStyled,
  FromContainerStyled,
  FromStyled,
  StreetContainerStyled,
  StreetStyled,
  TownContainerStyled,
  TownStyled,
  ViewDetailsStyled,
} from './AddressRow.style'
import leadIcon from 'assets/images/icons/app-lead.png'

export interface AddressRowProps {
  addressData: BasicAddressEntityType
  handleOpenAddressInfoModal: (BasicAddressEntityType) => void
  handleOpenLeadModal: (BasicAddressEntityType) => void
}

const AddressRow = (props: AddressRowProps) => {
  const { addressData, handleOpenAddressInfoModal, handleOpenLeadModal } = props
  const { t } = useTranslation()
  const [isHovered, setIsHovered] = useState(false)
  const [isFromHovered, setIsFromHovered] = useState(false)

  const onFromClick = (event, addressData: BasicAddressEntityType) => {
    event.preventDefault()
    event.stopPropagation()
    handleOpenLeadModal(addressData)
  }

  return (
    <StyledLink onClick={() => handleOpenAddressInfoModal(addressData)}>
      <AddressRowContainerStyled
        className="container"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <StreetContainerStyled isHovered={isHovered && !isFromHovered}>
          <StreetStyled>
            {addressData.street} {addressData.houseNumber}
          </StreetStyled>
          <ViewDetailsStyled isHovered={isHovered && !isFromHovered}>
            {t('addressList.addressColumn.viewDetails')}
          </ViewDetailsStyled>
        </StreetContainerStyled>
        <TownContainerStyled>
          <TownStyled
            title={`${addressData.zip || ''} ${addressData.town || ''}, ${addressData.nation}`}
          >
            {`${addressData.zip || ''} ${addressData.town || ''}`}, {addressData.nation}{' '}
          </TownStyled>
          <div style={{ display: 'flex' }}>
            <ChipStyled
              label={t(`objectType.${addressData.objectType.toLowerCase()}.tag`)}
              variant="outlined"
              style={{ marginRight: `${addressData.isCopy ? '' : '0px'}` }}
            />{' '}
            {addressData.isCopy && <img src={copyIcon} alt="copy.svg" />}
          </div>
        </TownContainerStyled>
        {addressData.importedFrom === 'LEAD' && (
          <FromContainerStyled>
            <FromStyled>{t('addressList.addressColumn.importedFrom')}</FromStyled>
            <div
              onClick={(event) => onFromClick(event, addressData)}
              onMouseEnter={() => setIsFromHovered(true)}
              onMouseLeave={() => setIsFromHovered(false)}
            >
              <FromButtonStyled isHovered={isFromHovered} isMainHovered={isHovered}>
                <img src={leadIcon} className="app-icon" alt="" />
                <span>Lead</span>
              </FromButtonStyled>
              <FromButtonDetailsStyled
                isMainHovered={isHovered}
                isHovered={isFromHovered}
                className="from-button-details"
              >
                {t('addressList.addressColumn.viewLead')}
              </FromButtonDetailsStyled>
            </div>
          </FromContainerStyled>
        )}
      </AddressRowContainerStyled>
    </StyledLink>
  )
}

export default AddressRow
